/* eslint-disable import/prefer-default-export */
import FilterInsights from './FilterInsights'

export default FilterInsights
